import { forwardRef, type ElementRef, type HTMLAttributes } from 'react'
import { cn } from '#app/utils/tailwind-merge.ts'

const Kbd = forwardRef<ElementRef<'kbd'>, HTMLAttributes<ElementRef<'kbd'>>>(({ className, ...props }, ref) => (
	<kbd
		ref={ref}
		className={cn('m-space-0 border-spacing-space-1 border-muted-200 bg-muted-50 p-space-4 font-code text-size-xs text-muted-900 rounded-lg border align-baseline shadow-sm', className)}
		{...props}
	/>
))
Kbd.displayName = 'Kbd'

export { Kbd }
